<template>
    <svg width="38" height="20" viewBox="0 0 38 20" xmlns="http://www.w3.org/2000/svg">
        <path d="M34.406.584a2.154 2.154 0 0 1 2.95 0 2.025 2.025 0 0 1 0 2.961L20.586 19.421c-.82.775-2.137.771-2.944-.007L.885 3.553A2.015 2.015 0 0 1 .224 2.06C.224 1.51.459.973.869.584a2.154 2.154 0 0 1 2.95 0L19.114 15.06 34.406.584z" fill="#FFF" fill-rule="evenodd"/>
    </svg>
</template>

<script>
export default {
    name: "IconScroll",
};
</script>
